<template>
  <div class="banner-activity">
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-input
        v-model="searchForm.activityName"
        placeholder="搜索活动名称"
        clearable
        class="search-input"
        size="small"
      />
      <el-button type="primary" @click="handleSearch" size="small"
        >搜索</el-button
      >
      <el-button icon="el-icon-refresh" plain @click="handleReset" size="small"
        >重置</el-button
      >
      <el-button
        icon="el-icon-plus"
        type="primary"
        @click="handleAdd"
        size="small"
        >新增</el-button
      >
    </div>

    <!-- 表格区域 -->
    <el-table :data="tableData" style="width: 100%; margin-top: 20px">
      <el-table-column prop="sortNum" label="序号" width="60" />
      <el-table-column prop="activityName" label="活动页名称" />
      <el-table-column prop="createBy" label="创建人" width="120" />
      <el-table-column prop="createTime" label="创建时间" width="220" />
      <el-table-column label="商品" width="120">
        <template slot-scope="{ row }">
          <el-button type="text" @click="handleSelectProducts(row)">
            已选商品({{ row.goodsNum }})
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
          <el-button type="text" @click="handleSelectProducts(row)"
            >选择商品</el-button
          >
          <el-button type="text" @click="handleCopyPCLink(row)"
            >PC链接</el-button
          >
          <el-button type="text" @click="handleCopyAPPLink(row)"
            >APP链接</el-button
          >
          <el-button type="text" @click="handleCopyYZSLink(row)"
            >云诊所链接</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination">
      <el-pagination
        :current-page.sync="page.current"
        :page-size.sync="page.size"
        :total="page.total"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 新增活动弹窗 -->
    <activity-dlg ref="activityDlg" @refresh="loadTableData" />
    <!-- 选择商品弹窗 -->
    <!-- 新增/编辑 -->
    <ClinicsCategoryGoodsSelectDlg
      ref="addGoodsRef"
      @refreshList="getGoodsList"
    />
  </div>
</template>

<script>
import activityDlg from "./components/addActivityDlg.vue";
import ClinicsCategoryGoodsSelectDlg from "./components/activityCategoryGoodsSelectDlg.vue";
import { activityList, deleteActivity } from "@/api/bannerManage";

export default {
  name: "BannerActivity",
  components: {
    activityDlg,
    ClinicsCategoryGoodsSelectDlg,
  },
  data() {
    return {
      searchForm: {
        activityName: "",
      },
      tableData: [],
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {
    this.loadTableData();
  },

  methods: {
    loadTableData() {
      let params = {
        current: this.page.current,
        size: this.page.size,
      };
      if (this.searchForm.activityName) {
        params.activityName = this.searchForm.activityName;
      }
      activityList(params)
        .then((res) => {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        })
        .catch((error) => {
          console.error("Error loading table data:", error);
        });
    },
    handleSearch() {
      this.page.current = 1;
      this.loadTableData();
    },
    handleReset() {
      this.searchForm.activityName = "";
      this.page.current = 1;
      this.loadTableData();
    },
    getGoodsList() {
      this.loadTableData();
    },
    handleAdd() {
      this.$refs.activityDlg.publicOpen();
    },

    handleEdit(row) {
      this.$refs.activityDlg.publicOpen(row);
    },

    handleDelete(row) {
      this.$confirm("确定要删除该活动吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteActivity({ id: row.id })
            .then(() => {
              this.$message.success("删除成功");
              this.loadTableData();
            })
            .catch((error) => {
              console.error("Error deleting activity:", error);
              this.$message.error("删除失败");
            });
        })
        .catch(() => {});
    },

    handleSelectProducts(row) {
      this.$refs.addGoodsRef.publicOpen(row);
    },

    handleViewProducts(row) {
      console.log("查看商品列表:", row);
    },
    handleCopyPCLink(row) {
      // activity?id=row.id
      const url = `activity?activityId=${row.id}`;
      this.copyToClipboard(url);
    },
    handleCopyAPPLink(row) {
      // pages/adActivity/index?activityId=row.id

      const url = `pages/adActivity/index?activityId=${row.id}`;
      this.copyToClipboard(url);
    },
    handleCopyYZSLink(row) {
      // 云诊所链接 http://10.17.1.1:60083/#/activity?activityId=1925751078038663170
      console.log(process.env.VUE_APP_BASE_API);

      const url = `${process.env.VUE_APP_YAOCHANCHAN_URL}/#/activity?activityId=${row.id}`;
      this.copyToClipboard(url);
    },
    // 添加一个通用的复制方法
    copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        // 对于 https 或 localhost 环境
        return navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$message.success("链接已复制到剪贴板");
          })
          .catch(() => {
            this.$message.error("复制失败");
          });
      } else {
        // 降级处理
        const textArea = document.createElement("textarea");
        textArea.value = text;
        // 将 textarea 添加到 DOM 中
        document.body.appendChild(textArea);
        // 选择文本
        textArea.select();
        try {
          document.execCommand("copy");
          this.$message.success("链接已复制到剪贴板");
        } catch (err) {
          this.$message.error("复制失败");
        } finally {
          // 清理 DOM
          document.body.removeChild(textArea);
        }
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.loadTableData();
    },

    handleCurrentChange(val) {
      this.page.current = val;
      this.loadTableData();
    },
  },
};
</script>

<style scoped lang="scss">
.banner-activity {
  padding: 20px;
  background-color: #fff;
  min-height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
}
.el-table {
  flex: 1;
  margin-bottom: 20px;
}
.search-area {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-input {
  width: 300px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
